<template>
  <h1>Add role to {{ organisation.name }}</h1>
  <form @submit.prevent="addRole">
    <div class="form-group mb-3">
      <label for="roleDescription" class="form-label">Description</label>
      <input type="text" id="roleDescription" class="form-control" v-model="roleDescription" ref="roleDescriptionInput"
             required>
    </div>
    <div class="form-group mb-3">
      <label for="roleMultiplier" class="form-label">Multiplier (%)</label>
      <input type="number" value="100" id="roleDescription" class="form-control" v-model="roleMultiplier" required>
    </div>
    <div v-if="nonFieldErrors.length" class="alert alert-danger mb-3">
      <ul class="mb-0">
        <li v-for="error in nonFieldErrors" :key="error">{{ error }}</li>
      </ul>
    </div>
    <div class="text-end">
      <button type="button" class="btn btn-secondary me-3" @click="cancel">Cancel</button>
      <button type="submit" class="btn btn-primary">Add role</button>
    </div>
  </form>
</template>

<script>
import {ref, onMounted} from "vue";
import {getCSRFToken} from "@/store/auth";
import {API_BASE_URL} from "@/config";

export default {
  props: {
    organisation: {
      type: Object,
      required: true
    }
  },
  emits: ['close'],
  setup(props, {emit}) {
    const roleDescription = ref('');
    const roleMultiplier = ref(100);
    const nonFieldErrors = ref([]);
    const roleDescriptionInput = ref(null);

    const addRole = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/organisations/${props.organisation.slug}/roles`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken() // Adjust the CSRF token retrieval according to your project
          },
          body: JSON.stringify({
            description: roleDescription.value,
            multiplier: roleMultiplier.value
          }),
          credentials: 'include'
        });

        if (response.ok) {
          const data = await response.json();
          console.log('Role added:', data);
          emit('close');
        } else {
          const errorData = await response.json();
          nonFieldErrors.value = errorData.non_field_errors;
          console.error('Error adding role:', errorData);
        }
      } catch (error) {
        console.error('Error adding role:', error);
      }
    };

    const cancel = () => {
      emit('close');
    }

    onMounted(() => {
      roleDescriptionInput.value.focus();
    });

    return {
      roleDescription,
      roleMultiplier,
      nonFieldErrors,
      addRole,
      cancel,
      roleDescriptionInput,
    }
  },
  methods: {
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.cancel();
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  }

}

</script>
